import { render } from "./leadActions.vue?vue&type=template&id=321c2a69&ts=true"
import script from "./leadActions.vue?vue&type=script&lang=ts"
export * from "./leadActions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__